import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import get from 'lodash/get';

import colors from '@app/constants/colors';
import footerLinks from '@app/constants/footerLinks';
import { Button } from '@app/components';
import RouterConstants from '@app/constants/router';

export const PaymentError = ({ error }) => (
  <React.Fragment>
    <Title>
      <FormattedMessage id={error ? `payment.errors.${get(error, 'code')}` : 'payment.unexpectedError'} />
    </Title>
    <Wrapper>
      <Button
        labelId="subscribe.tryAgain"
        textColor={colors.ALICE_BLUE}
        backgroundColor={colors.INTERNATIONAL_ORANGE}
        path={RouterConstants.SUBSCRIBE}
      />
    </Wrapper>
  </React.Fragment>
);

PaymentError.propTypes = {
  error: PropTypes.shape({
    code: PropTypes.number.isRequired,
    message: PropTypes.string,
  }),
};

PaymentError.defaultProps = {
  error: null,
};

export const SuccessfulPayment = () => (
  <React.Fragment>
    <Title>
      <FormattedMessage id="subscribe.downloadApp" />
    </Title>
    <Wrapper>
      <React.Fragment>
        <a href={footerLinks.downloadLinks.appstore} target="_blank" rel="noopener noreferrer">
          <Image src="/images/appstore.png" alt="appstore" />
        </a>
        <a href={footerLinks.downloadLinks.googleplay} target="_blank" rel="noopener noreferrer">
          <Image src="/images/googleplay.png" alt="googleplay" />
        </a>
      </React.Fragment>
    </Wrapper>
  </React.Fragment>
);

const Title = styled.p`
  color: ${colors.INTERNATIONAL_ORANGE};
  max-width: 820px;
  font-weight: bold;
  margin-bottom: 40px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  
  & a {
    margin: 0 25px;
  }
  
  @media (max-width: 979px) {
    & a {
      margin: 0 5px;
    }
  }    
`;

const Image = styled.img`
  max-width: 100%;
  height: auto;
  margin: 0;
`;
